import * as React from "react";
import {LeadEventType} from "../../model/lead/event/LeadEvent";
import LeadActivityNoteItem from "./items/LeadActivityNoteItem";
import LeadAppointmentStatusEvent from "../../model/lead/event/LeadAppointmentStatusEvent";
import LeadAppointmentEvent from "../../model/lead/event/LeadAppointmentEvent";
import Note from "../../model/note/Note";
import LeadActivityAppointmentItem from "./items/LeadActivityAppointmentItem";
import LeadQuoteFilesAttachedEvent from "../../model/lead/event/LeadQuoteFilesAttachedEvent";
import LeadQuoteCommentCreatedEvent from "../../model/lead/event/LeadQuoteCommentCreatedEvent";
import LeadQuoteStatusChangedEvent from "../../model/lead/event/LeadQuoteStatusChangedEvent";
import CommonStreamItem from "../../hiberUiKit/src/molecules/StreamItem/CommonStreamItem";
import LeadActivityQuoteItemWithAction from "./items/LeadActivityQuoteItemWithAction";
import LeadEmailSentEvent from "../../model/lead/event/LeadEmailSentEvent";
import CommonActivityEmailItem from "./items/CommonActivityEmailItem";
import LeadQuoteDeletedEvent from "../../model/lead/event/LeadQuoteDeletedEvent";
import LeadActivityQuoteDelete from "./items/LeadActivityQuoteDelete";
import LeadQuoteRestoredEvent from "../../model/lead/event/LeadQuoteRestoredEvent";
import LeadFilesAttachedEvent from "../../model/lead/event/LeadFilesAttachedEvent";
import LeadFilesAttachedItem from "./items/LeadFilesAttachedItem";

export type LeadActivityItemsType = LeadEventType | Note;

interface ComponentProps {
	/**
	 * Lead activity data.
	 */
	activityItems: LeadActivityItemsType[]
	/**
	 * Note id to set active class and focus on it.
	 */
	activeNoteId: string;
	/**
	 * Edit note click action.
	 * @param note note to edit.
	 */
	onEditNoteClick: (note: Note) => void;
	/**
	 * Edit appointment click action.
	 * @param appointment to edit.
	 */
	onEditAppointmentClick: (appointmentId: string) => void;
	/**
	 * Indicates if action are disabled
	 */
	readOnly?: boolean
}

type Props = ComponentProps;

/**
 * LeadActivityStreamItems component
 */
export default class LeadActivityStreamItems extends React.PureComponent<Props, {}> {
	render() {
		return this.props.activityItems.map((activity, index) => {
			const key = activity.id || index;
			if (activity instanceof Note) {
				return <LeadActivityNoteItem key={key} activity={activity}
											 isActive={this.isActive(activity.id)}
											 onEditNoteClick={this.props.onEditNoteClick}
											 readOnly={this.props.readOnly}/>

			}
			else if (activity instanceof LeadAppointmentEvent || activity instanceof LeadAppointmentStatusEvent) {
				return <LeadActivityAppointmentItem key={key}
													activity={activity}
													onEditAppointmentClick={this.props.onEditAppointmentClick}
													readOnly={this.props.readOnly}/>
			}
			else if (activity instanceof LeadQuoteCommentCreatedEvent
				|| activity instanceof LeadQuoteStatusChangedEvent
				|| activity instanceof LeadQuoteFilesAttachedEvent) {
				return <LeadActivityQuoteItemWithAction key={key}
														activity={activity}
														readOnly={this.props.readOnly}/>
			}
			else if (activity instanceof LeadQuoteDeletedEvent
				|| activity instanceof LeadQuoteRestoredEvent) {
				return <LeadActivityQuoteDelete key={key}
												activity={activity}
												readOnly={this.props.readOnly}/>
			}
			else if (activity instanceof LeadEmailSentEvent) {
				return <CommonActivityEmailItem key={key} activity={activity}/>
			}
			else if (activity instanceof LeadFilesAttachedEvent) {
				return <LeadFilesAttachedItem key={key} activity={activity}/>
			}
			else {
				return <CommonStreamItem key={key} event={activity}/>
			}
		})
	}

	/**
	 * Check if note is the active one.
	 */
	isActive(noteId: string): boolean {
		return this.props.activeNoteId === noteId;
	}
}
